module.exports = __webpack_public_path__ + "img/img8.e8d7fa72.jpg";